
import React from "react";

type SimilarBuilding = {
    building_id: string;
    building_name: string;
    kwh_per_sqft: string | number;
    therms_per_sqft: string | number;
};

interface Props {
    data: SimilarBuilding[] | undefined;
    open?: boolean;
}

const AnnualEnergyTargetSimilarBuildingList: React.FC<Props> = ({ data, open = false }) => {

    if (!data || data.length === 0) {
        return <div>No similar buildings available.</div>;
    }

    return (
        <div style={{width:'100%'}}>
            {open && (
                <div style={{maxHeight:'400px',overflowY:'auto',border:'1px solid black', marginTop:'1rem',borderRadius:'4px',padding:'8px'}}>
                    {/* <a style={{color:'white'}} href={`/?id=${b.building_id}&sec=buildings`}>{b.building_name}</a> */}
                <table style={{width:'100%',borderCollapse:'collapse'}}>
                    <thead>
                        <tr>
                            <th style={{textAlign:'left',borderBottom:'1px solid #ccc',padding:'8px'}}>Building</th>
                            <th style={{textAlign:'right',borderBottom:'1px solid #ccc',padding:'8px'}}>kWh / ft<sup>2</sup></th>
                            <th style={{textAlign:'right',borderBottom:'1px solid #ccc',padding:'8px'}}>Therms / ft<sup>2</sup></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(b => (
                            <tr key={b.building_id}>
                                <td style={{padding:'8px',borderBottom:'1px solid #eee'}}>
                                    <a href={`/?id=${b.building_id}&sec=buildings`} style={{color:'#eee'}}>{b.building_name}</a>
                                </td>
                                <td style={{padding:'8px',textAlign:'right',borderBottom:'1px solid #eee'}}>
                                    {b.kwh_per_sqft ?? '-'}
                                </td>
                                <td style={{padding:'8px',textAlign:'right',borderBottom:'1px solid #eee'}}>
                                    {b.therms_per_sqft ?? '-'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                </div>
            )}
        </div>
    );
};

export default AnnualEnergyTargetSimilarBuildingList;